import React, { useEffect, useState } from 'react';
import { KuposSteps, PaymentOptions } from '../../../common';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as actions from './../../redux/actions';
import * as homeActions from '../../../home/redux/actions';
import CommonService from '../../../../services/commonService';
import LoginBlock from '../../../Pasajebus/PasajebusPaymentDetails/LoginBlock/LoginBlock';
import CuponeraBookingInputs from '../../../common/Cuponera/BookingInputs/CuponeraBookingInputs';
import { AppData } from '../../../../services';
import ApiUrls from '../../../../services/apiUrls';

const CuponeraPaymentSelection = props => {
  const stepsMenu = [
    { label: 'GOING' },
    { label: 'PAYMENT', active: true },
    { label: 'CONFIRMATION' },
  ];

  let [countries, setCountries] = useState([]);
  let [idCardTypes, setIdCardTypes] = useState([]);
  const [paymentGatewayList, setPaymentGatewayList] = useState([]);
  let [inputs, setInputs] = useState({ country: countries[0], idCardType: idCardTypes[0] });
  const [selectedPaymentGateway, setSelectedpaymentGateway] = useState(null);
  const [cardChecked, setCardChecked] = useState(false);
  const [walletChecked, setWalletChecked] = useState(false);
  const [virtualChecked, setVirtualChecked] = useState(false);
  const [walletMoney, setWalletMoney] = useState(0);
  const [virtualMoney, setVirtualMoney] = useState(0);
  const [promoCodeChecked, setPromoCodeChecked] = useState(false);
  const [promoCode, setPromoCode] = useState({ val: '', error: '' });
  const [tncChecked, setTncChecked] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedSeats, setSelectedSeats] = useState({});
  const [pgError, setPgError] = useState(null);
  const [myCards, setMyCards] = useState([]);
  const [passengerInfoFromAPI, setPassengerInfoFromAPI] = useState(null);

  useEffect(() => {
    const loginData = props.common.loginData;
    console.log({ loginData });
    if (loginData)
      setInputs({
        ...inputs,
        email: loginData.email,
        confirmEmail: loginData.email,
        name: loginData.name,
        lastName: loginData.last_name,
        mobile: loginData.phone,
        idCardType:
          loginData.identity_type === 3
            ? { value: 3, label: 'DNI/Pasaporte' }
            : { value: 7, label: 'RUT (CHL)' },
        idCardNumber: loginData.identity_val,
      });
  }, [idCardTypes]);

  useEffect(() => {
    if (passengerInfoFromAPI)
      setInputs({
        ...inputs,
        email: passengerInfoFromAPI.email,
        confirmEmail: passengerInfoFromAPI.email,
        name: passengerInfoFromAPI.name.split('_')[0],
        lastName: passengerInfoFromAPI.name.split('_')[1],
        mobile: passengerInfoFromAPI.phone,
      });
  }, [passengerInfoFromAPI]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const summarySection = document.querySelector('.summary_block');
    summarySection.style.top = '200px';
  }, []);

  useEffect(() => {
    if (props.home.metaData) {
      let metaData = props.home.metaData;
      let countriesLocal = [];
      let idsLocal = [];

      for (let c in metaData.nationality_list) {
        countriesLocal.push({
          value: metaData.nationality_list[c],
          label: c.substring(0, 3).toUpperCase(),
        });
      }
      setInputs({ ...inputs, country: countriesLocal[0] });
      setCountries(countriesLocal);

      for (let c in metaData.id_card_types) {
        if (idCardTypes.length <= 1) {
          idsLocal.push({
            value: metaData.id_card_types[c],
            label: c,
          });
        }

        setInputs({ ...inputs, idCardType: idsLocal[0], country: countriesLocal[0] });
        setIdCardTypes(idsLocal);
      }

      let pgList = CommonService.copyObject(metaData.mot_pg_types);
      setPaymentGatewayList(pgList);
    }

    if (props.common) {
      setIsLoggedIn(CommonService.isLoggedIn());
    }

    if (props.common.loginData) {
      setWalletMoney(props.common.loginData.balances.clp.total);
      setVirtualMoney(props.common.loginData.balances.clp.credit);
    }

    if (props.home.cuponeraSeats) {
      setSelectedSeats(props.home.cuponeraSeats);
      setTotalAmount(props.home.cuponeraSeats.rate);
    } else {
      let localCuponera = sessionStorage.getItem('cuponeraSeats');
      if (localCuponera) {
        localCuponera = JSON.parse(localCuponera);
      }
      setSelectedSeats(localCuponera);
      setTotalAmount(localCuponera.rate);
    }
  }, [props]);

  useEffect(() => {
    getOneClickCards();
  }, []);

  const getOneClickCards = () => {
    //Get one click cards
    props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/my_cards_list',
        type: 'home',
      })
      .then(
        res => onOneClickCardsFetch(res),
        err => onOneClickCardsFetch(err),
      );
  };

  const onOneClickCardsFetch = result => {
    if (result && result.data && result.data.card_details) {
      setMyCards(result.data.card_details);
    } else if (result.data.status === 401) {
      setMyCards([]);
    }

    // setShowPaymentsOptions(true);
  };

  const onStepClick = i => {
    if (i === 1) {
      props.history.goBack();
    }
  };

  const onChange = (val, type) => {
    let error = `${type}Error`;

    if (type === 'idCardNumber' && inputs.idCardType.value === 7) {
      setInputs({ ...inputs, [type]: CommonService.formatRut(val), [error]: null });

      // callPassengerAPI(val);
    } else {
      setInputs({ ...inputs, [type]: val, [error]: null });
    }
  };

  const callPassengerAPI = idCardNumber => {
    props.actions
      .apiCall({
        url: ApiUrls.getPassengerInfo({
          cardType: inputs.idCardType.value,
          idCardNumber: idCardNumber && idCardNumber.replace(/[\.\-]/g, ''),
        }),
      })
      .then(res => {
        if (res && res.data && res.data.body) {
          let mydata = res.data.body;

          setPassengerInfoFromAPI(mydata);
        }
      });
  };
  const onPaymentTypeSelect = paymentItem => {
    if (paymentItem) {
      setSelectedpaymentGateway(
        selectedPaymentGateway === paymentItem.code ? null : paymentItem.code,
      );
      setCardChecked(false);
    } else {
      setSelectedpaymentGateway(34);
      setCardChecked(true);
    }
  };

  // useEffect(() => {
  // }, [selectedPaymentGateway, inputs]);

  const onPay = () => {
    let inputsLocalState = CommonService.copyObject(inputs);

    let errors = 0;
    if (!inputs.name) {
      inputsLocalState['nameError'] = 'VALIDATIONS.VALID_NAME';

      errors++;
    }
    if (!inputs.lastName) {
      inputsLocalState['lastNameError'] = 'VALIDATIONS.VALID_SURNAME';
      errors++;
    }
    if (!inputs.idCardNumber) {
      inputsLocalState['idCardNumberError'] = 'VALIDATIONS.VALID_RUT';
      errors++;
    }

    if (!inputs.email) {
      inputsLocalState['emailError'] = 'VALIDATIONS.VALID_EMAIL';
      errors++;
    }

    if (!inputs.confirmEmail) {
      inputsLocalState['confirmEmailError'] = 'VALIDATIONS.VALID_CONFIRM_EMAIL';
      errors++;
    }

    if (inputs.email && !CommonService.isEMailValid(inputs.email)) {
      inputsLocalState['emailError'] = 'VALIDATIONS.VALID_EMAIL_VALIDATION';
      errors++;
    }

    if (inputs.email && inputs.confirmEmail && inputs.email != inputs.confirmEmail) {
      inputsLocalState['confirmEmailError'] = 'VALIDATIONS.VALID_EMAIL_MATCH';
    }

    if (!inputs.mobile) {
      inputsLocalState['mobileError'] = 'VALIDATIONS.VALID_MOBILE';
      errors++;
    }

    setInputs(inputsLocalState);

    if (errors > 0) {
      return;
    }

    let origin = sessionStorage.getItem('cuponeraSourceCity');
    let dest = sessionStorage.getItem('cuponeraDestCity');

    if (origin && dest) {
      origin = JSON.parse(origin);
      dest = JSON.parse(dest);
    }

    let paymentTypeNumber = selectedPaymentGateway;
    if (walletChecked) {
      paymentTypeNumber = 50;
    }

    let data = {
      zone_id: selectedSeats.zone_id,
      origin_id: origin.value,
      destination_id: dest.value,
      api_travel_id: selectedSeats.api_travel_id,
      pay_gay_type: paymentTypeNumber,
      id_number: inputs.idCardNumber,
      id_type: inputs.idCardType ? inputs.idCardType.value : 7,
      title: 'Mr',
      passenger_name: inputs.name,
      phone_number: inputs.mobile,
      email: inputs.email,
      coupon_amount: selectedSeats.total_coupon_amount - selectedSeats.total_discount_amount,
      total_net_amount: selectedSeats.total_coupon_amount - selectedSeats.total_discount_amount,
    };

    setIsLoading(true);
    props.actions
      .apiCall({
        url: AppData.BASE_URL + `api/services/create_zone_mot_coupon`,
        method: 'POST',
        type: 'cuponera',
        data: data,
      })
      .then(res => {
        setIsLoading(false);
        console.log('Response from api', res);
        if (res && res.data && res.data.success && res.data.result) {
          if (res.data.result.html_str) {
            document.write(res.data.result.html_str);
          } else if (res.data.result.result.pnr_number) {
            props.history.push(`/cuponera/payment/success/${res.data.result.result.pnr_number}`);
          } else {
            props.history.push(`/cuponera/payment/success`);
          }
        } else {
          props.history.push('/cuponera/payment/failure');
        }
      });
  };
  const inputBlur = (text, type) => {
    if (!text) {
      if (type === 'name') {
        setInputs({ ...inputs, nameError: 'VALIDATIONS.VALID_NAME' });
      }
      if (type === 'lastName') {
        setInputs({ ...inputs, lastNameError: 'VALIDATIONS.VALID_SURNAME' });
      }
      if (type === 'idCardNumber') {
        setInputs({ ...inputs, idCardNumberError: 'VALIDATIONS.VALID_RUT' });
      }
      if (type === 'email') {
        setInputs({ ...inputs, emailError: 'VALIDATIONS.VALID_EMAIL' });
      }
      if (type === 'confirmEmail') {
        setInputs({ ...inputs, confirmEmailError: 'VALIDATIONS.VALID_CONFIRM_EMAIL' });
      }
      if (type === 'mobile') {
        setInputs({ ...inputs, mobileError: 'VALIDATIONS.VALID_MOBILE' });
      }
    } else {
      if (type === 'email' && !CommonService.isEMailValid(text)) {
        setInputs({ ...inputs, emailError: 'VALIDATIONS.VALID_EMAIL' });
      }
      if (type === 'confirmEmail' && !CommonService.isEMailValid(text)) {
        setInputs({ ...inputs, confirmEmailError: 'VALIDATIONS.VALID_CONFIRM_EMAIL' });
      }

      if (type === 'confirmEmail' && inputs.email && inputs.email != text) {
        setInputs({ ...inputs, confirmEmailError: 'VALIDATIONS.VALID_EMAIL_MATCH' });
      }

      if (type === 'idCardNumber') {
        callPassengerAPI(text);
      }
    }
  };
  const onPromoCodeChange = () => {};
  const onPromoCodeBlur = () => {};
  const onApplyPromoCode = () => {};

  return (
    <div>
      <div className="content-container">
        <KuposSteps menuButtons={stepsMenu} t={props.t} onStepClick={onStepClick} />

        <div
          style={styles.passenger_inputs_summary_wrapper}
          className="passenger_inputs_summary_wrapper"
        >
          <div style={styles.passenger_inputs_wrapper}>
            {!CommonService.isLoggedIn() ? <LoginBlock t={props.t} /> : null}

            {inputs && (
              <CuponeraBookingInputs
                idCardTypes={idCardTypes}
                countries={countries}
                passengerDetails={inputs}
                onChange={onChange}
                onInputBlur={inputBlur}
                seatsTitle="Información del pasajero"
                t={props.t}
              />
            )}

            <PaymentOptions
              paymentGatewayList={paymentGatewayList}
              //   selected={props.selected}
              selected={selectedPaymentGateway}
              onPaymentSelect={onPaymentTypeSelect}
              walletMoney={walletMoney}
              virtualMoney={virtualMoney}
              walletChecked={walletChecked}
              checkWallet={() => {
                setWalletChecked(!walletChecked);
                // setSelectedpaymentGateway(null);
              }}
              checkVirtual={() => setVirtualChecked(!virtualChecked)}
              virtualChecked={virtualChecked}
              // isLoggedIn={false}
              isLoggedIn={isLoggedIn}
              promoCodeChecked={promoCodeChecked}
              onPromoCheckboxChange={() => setPromoCodeChecked(!promoCodeChecked)}
              onPromoCodeChange={onPromoCodeChange}
              onPromoCodeBlur={onPromoCodeBlur}
              applyPromoCodePending={props.applyPromoCodePending}
              onApplyPromoCode={onApplyPromoCode}
              promoCodeError={promoCode.error}
              t={props.t}
              history={props.history}
              tncChecked={tncChecked}
              onTncChange={() => setTncChecked(!tncChecked)}
              totalAmount={totalAmount}
              showKuposPay={true}
              showPaypal={true}
              showPromocode={true}
              showBancoEstado={true}
              isOwnTravel={true}
              bookTicketPending={props.bookTicketPending}
              bookingError={props.bookingError}
              onBookingErrorClick={props.onBookingErrorClick}
              corporateDiscountState={props.corporateDiscountState}
              isLoading={isLoading}
              onPay={onPay}
              hideCreditos={true}
              // isOneClickEnabled={true}
              showCards={true}
              myCards={myCards}
            />
          </div>

          <SummarySection selectedSeats={selectedSeats} />
        </div>
      </div>
    </div>
  );
};

const SummarySection = ({ selectedSeats }) => {
  return (
    <div style={styles.summary_outer_box}>
      <div style={styles.summary_outer} className="summary_block">
        <div style={styles.summary} className="kupos-card">
          <div className="primary-text bold-text">Detalles de la compra</div>
          <div style={styles.yellow_line}></div>

          {selectedSeats && selectedSeats.coupon_amount && (
            <div>
              <div style={styles.operator_details}>
                <div className="font11" style={styles.operator}>
                  {selectedSeats.operator}
                </div>
                <div className="font11">{selectedSeats.no_of_coupons} Pasajeros</div>
              </div>

              <div style={styles.location_details}>
                <Place
                  icon={'/images/search-bar/search-bar-origin.svg'}
                  location={selectedSeats.origin}
                />
                <Place
                  icon={'/images/search-bar/search-bar-destination.svg'}
                  location={selectedSeats.destination}
                />
              </div>

              <div style={styles.line}></div>

              <div style={styles.seats_details} className="font11">
                <div className="font10">{selectedSeats.no_of_coupons} pasajes</div>
                <div className="font10 bold-text">
                  CLP {CommonService.currency(selectedSeats.total_coupon_amount)}
                </div>
              </div>

              <div style={styles.coupen_details} className="font11">
                <div className="font10">
                  <div>Codigo promocion:</div>
                  {/* <div>VIALIACONPULTMANE</div> */}
                </div>
                <div className="font10 bold-text primary-text">
                  CLP {CommonService.currency(selectedSeats.total_discount_amount)}
                </div>
              </div>
            </div>
          )}
        </div>
        {selectedSeats && selectedSeats.coupon_amount && (
          <div style={styles.price_tag_selected}>
            <div className="font10 bold-text">Total</div>
            <div className="font10 bold-text">
              CLP{' '}
              {CommonService.currency(
                selectedSeats.total_coupon_amount - selectedSeats.total_discount_amount,
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Place = ({ icon, location }) => {
  return (
    <div style={styles.place}>
      <img src={icon} style={styles.place_icon} alt="place" />
      <span className="font11">{location}</span>
    </div>
  );
};

const styles = {
  passenger_inputs_summary_wrapper: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    gap: 30,
    position: 'relative',
  },
  passenger_inputs_wrapper: {
    flex: 1,
  },
  summary_outer_box: {
    position: 'relative',
    width: '100%',
  },

  summary_outer: {
    width: '17.6%',
    position: 'fixed',
    top: 160,
  },
  summary: {
    zIndex: 100,
  },

  yellow_line: {
    height: 3,
    backgroundColor: '#f6ca3d',
    width: '45%',
    marginTop: 16,
    marginBottom: 16,
  },
  line: {
    height: 1,
    backgroundColor: '#013ba7',
    marginTop: 22,
    marginBottom: 22,
  },
  place_details: {
    marginTop: 22,
  },
  place: {
    display: 'flex',
    marginBottom: 6,
    alignItems: 'center',
  },
  place_icon: {
    width: 22,
    height: 'auto',
  },
  seat_type_details: {
    marginTop: 22,
  },
  section_2: {
    marginTop: 22,
  },
  location_pair: {
    margin: '6px 0',
  },
  operator_details: {
    margin: '12px 0',
  },
  operator: {
    marginBottom: 6,
  },
  location_details: {
    margin: '22px 0',
  },
  seats_details: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '32px 0',
  },
  coupen_details: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    margin: '32px 0',
  },
  price_tag_selected: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#fa5e00',
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    marginTop: -20,
    bottom: -22,
    paddingTop: 28,
    paddingBottom: 10,
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: 20,
    paddingLeft: 20,
    color: 'white',
    zIndex: -1,
  },
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...homeActions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(CuponeraPaymentSelection));



// WEBPACK FOOTER //
// ./src/features/home/Cuponera/PaymentSelection/index.js